export default {
  install(Vue, config) {
    Vue.number = (value, locale) => {
      if (!locale) {
        locale = config.locale();
      }

      return formatNumber(value, locale);
    };

    Vue.prototype.$number = function(value, locale) {
      if (!locale) {
        locale = config.locale();
      }

      return formatNumber(value, locale);
    };

    Vue.mixin({
      filters: {
        number(value, locale) {
          if (!locale) {
            locale = config.locale();
          }

          return formatNumber(value, locale);
        },
      },
    });
  },
};

function formatNumber(value, locale) {
  if (value === null) {
    return null;
  }

  if (!locale) {
    locale = "ro_RO";
  }

  locale = locale.replace("_", "-");

  const nf = new Intl.NumberFormat(locale);

  return nf.format(value);
}
